import React, { useState } from 'react'
import { BasicStyledComponent, DSFieldSelect } from 'shared-definitions/types'
import styles from './FieldSelect.module.css'
import clsx from 'clsx'
import ArrowBird from 'shared-svg/ArrowBottomBird.svg'
import { ResponsiveContext } from '../contexts/ResponsiveContext'
import { useOutsideClick } from '../hooks/use-outside-click'

interface FieldSelectProps extends BasicStyledComponent {
  field: Omit<DSFieldSelect, 'type'>
  onChange: (value: string | null) => void
  value: string
}

export const FieldSelect: React.FC<FieldSelectProps> = ({ value, field, className, onChange }) => {
  const { ready, md } = ResponsiveContext.useContainer()
  const [open, setOpen] = useState(false)
  const ref = useOutsideClick<HTMLDivElement>(() => {
    setOpen(false)
  }, [])
  return (
    <div className={clsx(className, styles.container)} ref={ref}>
      <select
        className={clsx(styles.select, {
          [styles.disabled]: !value,
        })}
        value={value}
        onChange={e => {
          onChange(e.target.value === '' ? null : e.target.value)
        }}
      >
        {field.placeholder && (
          <option disabled value="">
            {field.placeholder}
          </option>
        )}
        {field.options.map(option => (
          <option key={option.value} value={option.value ?? ''}>
            {option.label}
          </option>
        ))}
      </select>
      <ArrowBird className={styles.icon} />
      {ready && md && (
        <>
          <button
            type="button"
            className={styles.dropDownTriggerOverlay}
            onClick={() => {
              setOpen(o => !o)
            }}
          />
          <div
            className={clsx(styles.dropDown, {
              [styles.dropDownOpen]: open,
            })}
          >
            {field.options.map(option => (
              <button
                type="button"
                key={option.value}
                className={styles.dropDownButton}
                onClick={() => {
                  onChange(option.value)
                  setOpen(false)
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
